module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.open) ? _c('div', {
    key: "modal",
    class: _vm.modalClass,
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    class: ['modal-dialog', 'modal-' + _vm.size]
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.slotExists('header')) ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.slotExists('footer')) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    key: "modal-backdrop",
    class: _vm.modalBackdropClass
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e467251e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/modals/BaseModal.vue
// module id = 678
// module chunks = 5